module.exports = __webpack_public_path__ + "img/excenatideER_2.2ea71b5a.jpg";